module.exports = __webpack_public_path__ + "img/newsImg3-4.b2e009d4.png";